export default __webpack_public_path__ + "static/media/facebook-color.1c0ce642.svg";